import { useEffect, useState } from 'preact/hooks';
import { getLocationConsent } from 'services/globalConfig.services';

export const useLocationConsent = (): {
  isAllowGoogleMaps: boolean;
} => {
  const [isAllowGoogleMaps, setIsAllowGoogleMaps] = useState<boolean>();

  useEffect(() => {
    setIsAllowGoogleMaps(getLocationConsent() === 'true');
  }, []);

  return {
    isAllowGoogleMaps,
  };
};
